"use client"

import dynamic from "next/dynamic"

export const LoginBoxDynamic = dynamic(
  () => import("@/app/login/LoginBox").then((mod) => mod.LoginBox),
  {
    ssr: false,
  }
)
